<template>
	<div class="lang-selector-container">
		<div class="lang-selector-item" v-for="(language, index) in languages" :key="index" @click="setActiveLang(index);" :class="{'lang-selector-item-active': isLangActive(language.name)}">
			<span class="lang-selector-text">{{getLangString(language.code)}}</span>
		</div>
	</div>
</template>

<script>

import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';

export default {
	name: 'LangSelector',
	props: {
		languages: [Array],
	},
	mixins: [staticDataLoaderMixin],
	created() {
		this.getActiveLang();
	},
	methods: {
		getActiveLang() {
			const actLang = localStorage.getItem('activeLanguage');
			if (actLang && this.languages.find(e => e.name === actLang)) {
				this.updateLanguage(actLang);
			} else {
				this.updateLanguage(this.languages[0].name);
			}
		},
		setActiveLang(index) {
			const actLang = this.languages[index].name;
			localStorage.setItem('activeLanguage', actLang);
			this.updateLanguage(actLang);
		},
	},
	computed: {
		getLangString() {
			return langCode => langCode.toUpperCase();
		},
		isLangActive() {
			return (langName) => {
				const actLang = this.language;
				if (langName === actLang) {
					return true;
				}
				return false;
			};
		},
	},
};
</script>

<style src="@/styles/components/LanguageSelector/LanguageSelector.less" lang="less" scoped></style>
